// Map all env vars to JS vars in one file to avoid having `process` everywhere
const ENV = {
  SHOW_NEXT_VERSION_WARNING: process.env.SHOW_NEXT_VERSION_WARNING === 'true',
  COLLECT_ANALYTICS: process.env.COLLECT_ANALYTICS === 'true',
  APPINSIGHTS_CONNECTIONSTRING: process.env.CONNECTION_STRING,
  COMPONENT_VERSIONS: process.env.COMPONENT_VERSIONS,
  ADD_PRIMEVUE_STYLES: process.env.ADD_PRIMEVUE_STYLES === 'true',
  MERCHANT_APP_URL: process.env.MERCHANT_APP_URL,
};

export {
  ENV,
};
